import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (process.env.NODE_ENV === "production") {
    const hideIfSensitive = (method, args) => {
        const text = args
            .map((a) => {
                if (typeof a === "string") return a;
                try {
                    return JSON.stringify(a);
                } catch {
                    return String(a);
                }
            })
            .join(" ");
        return /supabase\.co|eyJ[a-zA-Z0-9_-]*\.eyJ|gaspayments|postgrest|GoTrueClient/i.test(
            text,
        );
    };
    ["log", "info", "debug", "warn", "error"].forEach((method) => {
        const original = console[method].bind(console);
        console[method] = (...args) => {
            if (hideIfSensitive(method, args)) return;
            original(...args);
        };
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
